import React from "react"
import { FormattedMessage } from "react-intl"
// Material Ui
import Button from "@material-ui/core/Button"
import { propTypes, containedPrimary } from "./ButtonPropTypes"

const ButtonNew = (props) => (
  <Button className="btn-light" {...props}>
    <i aria-hidden="true" className="fa fa-plus icon-left" />
    <FormattedMessage
      defaultMessage="New"
      description="Button New"
      id="button.new"
    />
  </Button>
)

ButtonNew.propTypes = propTypes
ButtonNew.defaultProps = containedPrimary

export default ButtonNew
